<template>
  <bk-view v-if="showTabFlag" class="view-appTabs" :class="[deviceType]">
<!--    <bk-view class="view-blur"></bk-view>-->
    <bk-view class="view-tab-content">
      <bk-view class="view-tabItem" v-for="(item, index) in tabsList" :class="[item.path == curTabItem.path ? 'select' : '']" :key="index" @click="tabItemClick(item)">

        <template v-if="item.path != curTabItem.path">
          <bk-icon v-if="item.icon" :icon="item.icon"></bk-icon>
          <bk-view class="view-text">
            <bk-lang :code="item.langCode"></bk-lang>
          </bk-view>
        </template>
        <template v-else>
          <bk-icon v-if="item.iconS" :icon="item.iconS"></bk-icon>
          <bk-view v-if="item.iconS" class="view-text">
            <bk-lang :code="item.langCode"></bk-lang>
          </bk-view>
        </template>

        <bk-image v-if="item.imgUrl" :src="item.imgUrl"></bk-image>

      </bk-view>
    </bk-view>
  </bk-view>
</template>

<script>
	import BkLang from '../../../../components/bk-base/bk-lang/bk-lang';
	import BkImage from '../../../../components/bk-base/bk-image/bk-image';
	export default {
		name: 'appTabs',
		components: {BkImage, BkLang},
		data () {

			let tabsList = [
				{
					icon: 'icon-Explore',
					imgUrl: this.$bk_getImageUrl('Def_Tab_Home_S.png?v=12321'),
					key: 'home',
					langCode: 'appTabs_tab_home',
					path: '/home',
				},
				{
					icon: 'icon-Appointments',
					iconS: 'icon-Appointments-S',
					key: 'appointments',
					langCode: 'appTabs_tab_appointments',
					path: '/appointments'
				},
				{
					icon: 'icon-Favorite',
					iconS: 'icon-Favorites-S',
					key: 'favorites',
					langCode: 'appTabs_tab_favorites',
					path: '/favorites'
				},
				{
					icon: 'icon-Me',
					iconS: 'icon-Me-S',
					key: 'profile',
					langCode: 'appTabs_tab_me',
					path: '/userInfo'
				}
			];

			let shopDetailId = localStorage.getItem('ShopDetailId');
			let shopDetailCustId = localStorage.getItem('ShopDetailCustId') || '';
			

			console.log('ShopDetailId::::', shopDetailId);

			if (shopDetailId && shopDetailId != '') {
				tabsList = [
					{
						icon: 'icon-Appointments',
						imgUrl: this.$bk_getImageUrl('Def_Tab_Home_S.png?v=12321344'),
						key: 'Reserve',
						langCode: 'appTabs_tab_shop',
						path: shopDetailId == '387270844529770497' ? '/detail/DSSTUDIO' : `/shopDetail?compId=${shopDetailId}&custId=${shopDetailCustId}`,
					},
					{
						icon: 'icon-Appointments',
						iconS: 'icon-Appointments-S',
						key: 'appointments',
						langCode: 'appTabs_tab_appointments',
						path: '/appointments'
					},
					{
						icon: 'icon-Me',
						iconS: 'icon-Me-S',
						key: 'profile',
						langCode: 'appTabs_tab_me',
						path: '/userInfo'
					}
				];
			}

			if (window.kisDZFlag) {

				bkLog.log('shopDetailCustId:::', shopDetailCustId);

				tabsList = [
					{
						icon: 'icon-home-off',
						iconS: 'icon-home-on',
						key: 'Reserve',
						langCode: 'appTabs_tab_shop',
						path: `/shopDetail?compId=${shopDetailId || '483351635912097793'}&custId=${shopDetailCustId || 'KISHAIR'}`,
					},
					{
						icon: 'icon-Appointments-off',
						iconS: 'icon-Appointments-on',
						key: 'appointments',
						langCode: 'appTabs_tab_appointments',
						path: '/appointments'
					},
					{
						icon: 'icon-Profile-off',
						iconS: 'icon-Profile-on',
						key: 'profile',
						langCode: 'appTabs_tab_me',
						path: '/userInfo'
					}
				];
			}

			if (window.oblissDZFlag) {

				bkLog.log('shopDetailCustId:::', shopDetailCustId);

				tabsList = [
					{
						icon: 'icon-home-off',
						iconS: 'icon-home-on',
						key: 'Reserve',
						langCode: 'appTabs_tab_shop',
						path: `/shopDetail?compId=${shopDetailId || '504548360373370880'}&custId=${shopDetailCustId || 'OBLISSBEAUTYSALON'}`,
					},
					{
						icon: 'icon-Appointments-off',
						iconS: 'icon-Appointments-on',
						key: 'appointments',
						langCode: 'appTabs_tab_appointments',
						path: '/appointments'
					},
					{
						icon: 'icon-Profile-off',
						iconS: 'icon-Profile-on',
						key: 'profile',
						langCode: 'appTabs_tab_me',
						path: '/userInfo'
					}
				];
			}

			if (window.komoDZFlag) {

				bkLog.log('shopDetailCustId:::', shopDetailCustId);

				tabsList = [
					{
						icon: 'icon-home-off',
						iconS: 'icon-home-on',
						key: 'Reserve',
						langCode: 'appTabs_tab_shop',
						path: `/shopDetail?compId=${shopDetailId || '514941760328925184'}&custId=${shopDetailCustId || 'KOMO'}`,
					},
					{
						icon: 'icon-Appointments-off',
						iconS: 'icon-Appointments-on',
						key: 'appointments',
						langCode: 'appTabs_tab_appointments',
						path: '/appointments'
					},
					{
						icon: 'icon-Profile-off',
						iconS: 'icon-Profile-on',
						key: 'profile',
						langCode: 'appTabs_tab_me',
						path: '/userInfo'
					}
				];
			}

			if (window.mlDemoFlag) {
				tabsList = [
					{
						icon: 'icon-home-off',
						iconS: 'icon-home-on',
						key: 'DemoIndex',
						langCode: 'appTabs_tab_shop',
						path: '/home'
					},
					{
						icon: 'icon-Appointments-off',
						iconS: 'icon-Appointments-on',
						key: 'appointments',
						langCode: 'appTabs_tab_appointments',
						path: `/shopDetail?compId=${shopDetailId || '483351635912097793'}&custId=${shopDetailCustId || 'KISHAIR'}`,
					},
					{
						icon: 'icon-Profile-off',
						iconS: 'icon-Profile-on',
						key: 'profile',
						langCode: 'appTabs_tab_me',
						path: '/userInfo'
					}
				];
			}

			bkLog.log('tabsList:::', this.$bk_copy(tabsList));

			return {
				deviceType: this.$bk_getDeviceType(),
				curTabItem: tabsList[0],
				tabsList,
				showTabFlag: true,
			};
		},
		created () {

			let that = this;

			window.setTabShow = function (flag) {
				that.showTabFlag = flag;
			};

			this.refreshCurTab();
		},
		methods: {
			refreshCurTab: function () {

				let pagePath = this.$route.path;

				let menuItem = this.tabsList.filter(function (obj) {
					return obj.path == pagePath;
				})[0];

				if (menuItem) {
					this.curTabItem = menuItem;
				}
			},

			tabItemClick (item) {

				this.curTabItem = item;

				this.$router.push(item.path);
			},
		}
	};
</script>

<style scoped lang="less">

.view-appTabs {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding-bottom: calc(1px + env(safe-area-inset-bottom)) ;
  z-index: 10;
  border-top: .5px solid rgba(220, 220, 220, .3);
  overflow: hidden;
  background: rgba(255, 255, 255, .9);
  backdrop-filter: blur(5px);

  &.PC {
    right: 0;
    margin: auto;
    max-width: @pc-max-width;
  }

  > .view-tab-content {
    position: relative;
    z-index: 1;
    display: flex;
    height: 49px;


    > .view-tabItem {
      flex: 1;
      text-align: center;
      padding-top: 10px;

      &.select {
        > .bk-icon {
          color: var(--color-main);
        }
        > .view-text {
          color: var(--color-main);
        }
        > .bk-image {
          display: inline-block;
        }
      }

      > .bk-icon {
        color: @color-text-def;
        font-size: 20px;
        line-height: 20px;
        height: 20px;
      }

      > .view-text {
        font-size: @font-tip;
        transform: scale(.9);
        .fontBloder();
        color: @color-text-999;
        line-height: 14px;
        height: 14px;
      }

      > .bk-image {
        display: none;
        .marginCenterAuto(5px, 0, auto, 0);
        width: 40px;
        height: 40px;
      }
    }
  }
}

</style>